<template>
    <div class="subheader" v-if="currentErrand">
        <div class="subheader-wrap">
            <div class="subheader-left">
            <h1>{{ currentErrand.address }}</h1>
            <span class="header__subheading">{{ currentErrand.name }}</span>
            </div>

            <div class="subheader-props">
              <div class="subheader-props__item">
                <div class="subheader-props__key">{{ $t('errands.status') }}</div>
                <div class="subheader-props__value">{{ getErrandStatus(currentErrand) }}</div>
              </div>

              <div class="subheader-props__item">
                <div class="subheader-props__key">{{ $t('overview.requestId') }}</div>
                <div class="subheader-props__value">{{ currentErrand.request_id }}</div>
              </div>
            </div>

        </div>

    </div>
</template>

<script>
import errandService from '@/core/services/errand-service'

export default {
  methods: {
    getErrandStatus: errandService.getErrandStatus
  }
}
</script>

<style lang="scss" scoped>
section.subheader-container {
  margin-bottom: measure(l);
}

.subheader {
  background-color: color(white);
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}

.subheader-wrap {
  position: relative;
  display: flex;
  min-width: 100%;
  max-width: $page-max-width;
  padding: measure(l);
  justify-content: space-between;

  @media #{$mq-mobile-only} {
    flex-wrap: wrap;
  }
}

.subheader-left {
  width: calc(#{$page-max-width}/ 2 + #{measure(s)}/ 2);
  display: flex;
  flex-direction: column;
}

.subheader-props {
  display: flex;
  color: color(jet);
  font-weight: $font-weight-medium;
  @media #{$mq-mobile-only} {
    margin-top: measure(xs);
  }
}

.subheader-props__item {
  margin-right: measure(xl);
}

.subheader-props__key {
  // font-family: arial;
  color: color(medium);
  @include font-size(s);
  text-transform: uppercase;
  margin-bottom: measure(xxs);
}
</style>
